import { useEffect } from "react";
import { Link } from "react-router-dom";
import MarketingPageLayout from "../../components/marketing/MarketingPageLayout";
import { BRAND_NAME, COMPANY_LEGAL_NAME } from "../../constants/brand";
import {
  CONTACT_EMAILS,
  CONTACT_PHONES,
  OFFICE_ADDRESS,
  openSupportMail,
} from "../../constants/contact";
import "../../styles/auth.css";

export default function RefundPolicyPage() {
  useEffect(() => {
    const previousTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const previousDescription = meta?.getAttribute("content") || "";
    document.title = `Refund and Cancellation Policy | ${BRAND_NAME}`;
    if (meta) {
      meta.setAttribute(
        "content",
        "FastSearch refund and cancellation policy, Razorpay payment methods, and SSDI contact details."
      );
    }
    return () => {
      document.title = previousTitle;
      if (meta) meta.setAttribute("content", previousDescription);
    };
  }, []);

  return (
    <MarketingPageLayout wide>
      <header className="marketing-page__hero">
        <p className="terms-hero__eyebrow">Legal · FastSearch Website</p>
        <h1 className="marketing-page__title">Refund and Cancellation Policy</h1>
        <p className="marketing-page__lead">
          FastSearch App/Web ({COMPANY_LEGAL_NAME})
        </p>
      </header>

      <div className="marketing-panel">
        <h2>Refund and Cancellation Policy</h2>
        <p>
          We do not provide any return or refund of the purchased SaaS product. In case of extreme
          situation or request dispute, the refund will be credited to the client&apos;s account
          between 5 to 7 days.
        </p>

        <h2>Payment Flow</h2>
        <p>
          Our website is integrated with the Razorpay payment gateway, through which clients can
          make their monthly payment subscription through the website itself. There are different
          payment methods provided for consumers, including payment through Debit card, UPI, Net
          banking, and others.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions about this policy, you can contact us:
        </p>
        <p>
          <strong>Company Name:</strong> {COMPANY_LEGAL_NAME} (FastSearch App/Web)
        </p>
        <p>
          <strong> Founder Name :</strong> Ashwani Kumar
        </p>
        <p>
          <strong>Email:</strong>{" "}
          {CONTACT_EMAILS.map((item, index) => (
            <span key={item.email}>
              {index > 0 ? ", " : null}
              <a
                href={`mailto:${item.email}`}
                onClick={index === 0 ? openSupportMail : undefined}
              >
                {item.label}
              </a>
            </span>
          ))}
        </p>
        <p>
          <strong>Phone number:</strong>{" "}
          {CONTACT_PHONES.map((phone, index) => (
            <span key={phone.tel}>
              {index > 0 ? ", " : null}
              <a href={`tel:${phone.tel}`}>{phone.label}</a>
            </span>
          ))}
        </p>
        <p>
          <strong>Address:</strong> {OFFICE_ADDRESS}
        </p>
      </div>

      <div className="marketing-page__actions">
        <Link to="/" className="primary-page-btn">
          ← Back to Login
        </Link>
      </div>
    </MarketingPageLayout>
  );
}
